<template>
    <div class="md-layout">
      <md-dialog-alert
        :md-active.sync="error_dialog.show"
        :md-title="error_dialog.title"
        :md-content="error_dialog.content"/>
        <!-- Status -->
        <div class="md-layout-item view-settlement">
            <group-card :title="'SETTLEMENT REQUEST APPLICATION: '+this.application_id" icon="fact_check">
                <md-empty-state
                    class="md-primary"
                    md-icon="chair"
                    md-label="Empty"
                    md-description="Settlement request has not been made for this application."
                    v-if="settlementData==null"
                >
                </md-empty-state>
                <form class="md-layout" v-if="settlementData!=null">
                    <div class="md-layout-item md-size-50 md-small-size-100">
                        <md-card-content>
                            <div class="md-layout md-gutter">
                                <div class="md-layout-item md-small-size-100">
                                    <md-field>
                                        <label for="broker">Broker</label>
                                        <md-input name="broker" id="broker" v-bind:value="broker | name" disabled/>
                                    </md-field>
                                </div>
                            </div>
                            <div class="md-layout md-gutter">
                                <div class="md-layout-item md-small-size-100">
                                    <md-field>
                                        <label for="client">Client</label>
                                        <md-input name="client" id="client" v-bind:value="client | name" disabled/>
                                    </md-field>
                                </div>
                            </div>
                            <div class="md-layout md-gutter">
                                <div class="md-layout-item md-small-size-100">
                                    <md-field>
                                        <label for="lender">Lender</label>
                                        <md-input name="lender" id="lender" v-model="lender" disabled/>
                                    </md-field>
                                </div>
                                <div class="md-layout-item md-small-size-100">
                                    <md-field>
                                        <label for="loan-term">Loan Term</label>
                                        <md-input name="loan-term" id="loan-term" v-model="settlementData.submission.term" disabled/>
                                    </md-field>
                                </div>
                                <div class="md-layout-item md-small-size-100">
                                    <md-field>
                                        <label for="rate">Rate</label>
                                        <md-input name="rate" id="rate" v-model="settlementData.submission.rate" disabled/>
                                    </md-field>
                                </div>
                              <div class="md-layout-item md-small-size-100">
                                <md-field>
                                  <label for="rate">Loan Amount</label>
                                  <md-input name="loan_amount" id="loan_amount" v-model="security.requested_amount" disabled/>
                                </md-field>
                              </div>
                            </div>
                            <div class="small-info-title">Financed Insurances</div>
                          <InsuranceComponent :insurances="insurances" :disabled="is_settled">
                          </InsuranceComponent>
                          <br/>
                          <md-field>
                              <label>Notes</label>
                              <md-textarea v-model="notes" :disabled="is_settled"></md-textarea>
                          </md-field>
                          <md-card-actions>
                              <md-button class="md-primary text-right" v-on:click="settleApplication" v-if="!is_settled">Settle</md-button>
                          </md-card-actions>
                        </md-card-content>
                    </div>
                </form>
            </group-card>
        </div>
    </div>
</template>
<script>
import {GroupCard} from "@/components";
import {mapGetters} from 'vuex';
import filters from "@/components/utils/filters";
import {ValidatedTextInput, ValidatedSelectInput} from "@/components";
import WaitingDialog from "@/components/Dialogs/WaitingDialog";
import InsuranceComponent from "@/components/InsuranceComponent";
import ConfirmDialog from "../../components/Dialogs/ConfirmDialog";

export default {
    components: {
        GroupCard,
        ValidatedTextInput,
        ValidatedSelectInput,
        InsuranceComponent
    },
    computed: {
        ...mapGetters([
            'assessment',
            'options',
            'application',
            'security',
        ]),
    },
    mounted() {
        this.getExistingSettlement();
    },

    methods: {
        setExistingValues() {
            this.broker = this.settlementData.loan_application.user;
            this.insurances = this.settlementData.loan_application.loan.insurances;
            this.invoice_attached = this.settlementData.has_invoice_attached;
            this.approval_attached = this.settlementData.has_approval_attached;
            this.client_advised = this.settlementData.is_client_advised;
            this.suncrop_quoted = this.settlementData.is_suncrop_quoted;
            this.certified_id = this.settlementData.has_certified_id;
            this.insurance_coc = this.settlementData.has_insurance_coc;
            this.notes = this.settlementData.notes;
            this.finance_insurances = this.settlementData.financed_insurances;
            this.outstanding_condition_note = this.settlementData.outstanding_details;
            this.client = this.settlementData.loan_application.applicants[0].contact.name;
            if (this.settlementData.product_lender) {
                this.lender = this.settlementData.product_lender.lender_name;
            }
            this.loan.term = this.settlementData.loan_application.loan.requested.term;
            this.loan.amount = this.settlementData.loan_application.loan.requested.amount;
            this.is_settled = this.settlementData.is_submitted
        },
        async getExistingSettlement() {
            try {
                let result = await this.$store.dispatch('get_existing_settlement', this.application_id);
                if (result != false) {
                    this.settlementData = result;
                    this.setExistingValues();
                    if (this.is_settled) {
                      this.showNotification('This application has already been settled.', 'Info!')
                    }
                }
            } catch (error) {
                console.log(error);
            }
        },
      async settleApplication() {
        this.showModal('Please wait whilst the settlement request is being processed.','Processing');
        this.isSaving = true
        this.send_to_officer = false;
        this.application.loan.insurances = this.insurances
        let settlement = {
          "loan_application_id": this.application.loan.id,
          "settlement_officer_id": 1,
          "has_invoice_attached": this.invoice_attached,
          "has_approval_attached": this.approval_attached,
          "is_client_advised": this.client_advised,
          "is_suncrop_quoted": this.suncrop_quoted,
          "has_certified_id": this.certified_id,
          "has_insurance_coc": this.insurance_coc,
          "outstanding_details": this.outstanding_condition_note,
          "notes": this.notes,
          "broker": this.broker,
          "application": this.application,
          "send_to_officer": this.send_to_officer,
          'settlement_id': this.settlementData.id,
        }
        let result = await this.$store.dispatch('save_settlement_request', settlement);
        if (result === true) {
          if (this.$modal.submit) {
            this.$modal.submit();
          }
          await this.showConfirmationBox(
            'Confirmation',
            '',
            'Generate and Send to customer',
            'Generate Docs',
            'Confirm Lender, NAF, Term, Fees and insurances are correct before proceeding.'
          ).then(response => {
            this.generateDocumentAndSend(response);
          }).catch(reason=>{
            console.log(reason);
          });
        } else{
          this.showNotification("Could not submit this application for settlement.", "Error!");
        }
      },
      async generateDocumentAndSend(sendForSignature = false) {
        await this.generateSettlementDocuments(sendForSignature);
      },
      async generateSettlementDocuments(sendForSignature = false)
      {
        //only generate and send  documents for settlement if its self settle
        let settlementMessage = "Please wait whilst the settlement documents are being generated.";
        let successMessage = "Documents has been generated.";
        if(sendForSignature) {
          settlementMessage = "Please wait whilst the settlement documents are being generated and sent to the customer for signature.";
          successMessage ="Documents have been generated and sent to customer for signature";
        }
        this.showModal(settlementMessage, 'Generating Settlement Documents.');
        let docusignResult = await this.$store.dispatch('generate_settlement_documents', {'application_id':this.application.loan.id, "settlement_id": this.settlementData.id, 'sendForSignature': Number(sendForSignature)});
        if(docusignResult.status == 200) {
          if (this.$modal.submit) {
            this.$modal.submit();
          }
          this.showNotification(successMessage, 'Success');
          this.is_settled = true;
        }
        else {
          if (this.$modal.submit) {
            this.$modal.submit();
          }
          this.showNotification("Could not generate and settlement documents.","Error!");
        }
      },
      showModal(message, title){
        this.$modal.show(WaitingDialog, {
          title: title,
          message: message,
        });
      },
      showNotification(message, title)
      {
        this.error_dialog.show = true;
        this.error_dialog.content = message;
        this.error_dialog.title = title;
        this.isSaving = false;
      },
      showConfirmationBox(title, content, confirmText, cancelText, importantMsg){
        return this.$modal.show(ConfirmDialog,{
          title: title,
          message: content,
          confirmText: confirmText,
          cancelText: cancelText,
          important: importantMsg,
          confirmDisabled: true, // TODO: Enable this. Send to customer for Docusign functionality been disabled for past year.
        });
      },

    },
    filters: {
        ...filters,
    },
    data() {
        return {
            broker: '',
            client: '',
            lender: '',
            loan: {},
            invoice_attached: false,
            approval_attached: false,
            client_advised: false,
            suncrop_quoted: false,
            finance_insurances: '',
            certified_id: false,
            insurance_coc: false,
            outstanding_condition_note: '',
            notes: '',
            snackbar: {
                show: false,
                icon: 'done',
                content: '',
            },
            application_id: this.$route.params.id,
            settlementData: null,
            isSaving: false,
            is_settled: false,
            error_dialog: {
              show: false,
              title: '',
              content: '',
            },
        }
    }
}
</script>
<style scoped>
.small-info-title {
    font-weight: bold;
    margin-top: 5px;
}
</style>
